export var InvoiceChildFieldType;
(function (InvoiceChildFieldType) {
    InvoiceChildFieldType["QBO_CUSTOM_FIELD"] = "qbo_custom_field";
    // Add things like Xero tracking etc
})(InvoiceChildFieldType || (InvoiceChildFieldType = {}));
//# sourceMappingURL=invoiceChildField.js.map